import { motion } from "framer-motion";

export const ProgressBar = ({ current, total }) => {
  const pct = Math.round((current / total) * 100);
  return (
    <div className="mb-8" data-testid="progress-wrapper">
      <div className="mb-2 flex items-center justify-between text-xs font-medium text-ink/55">
        <span data-testid="progress-label">
          Domanda {current} di {total}
        </span>
        <span>{pct}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-ink/10">
        <motion.div
          className="h-full rounded-full bg-coral"
          initial={false}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          data-testid="progress-fill"
        />
      </div>
    </div>
  );
};
